import authHeader from "../../../authentication/authservices/auth-header";
import apiClient from "../../../http-common";

export const getDischargeStatusData = (admissionId) => {
  return apiClient.get(`/clinicalCareChart/dischargeStatus/${admissionId}`, {
    headers: authHeader(),
  });
};
